export const baseURL = process.env.NODE_ENV === 'development' ? 
  'https://us-central1-pupford-6b94c.cloudfunctions.net/webApi/dev' :
  'https://us-central1-pupford-6b94c.cloudfunctions.net/webApi';

export const stripeKey = process.env.NODE_ENV === 'development' ?
  'pk_test_gzLrbGgJY2xFPWIwtMNkTjly' :
  'pk_live_jGZmun3QbNNGYbcaoGL6k5yR';
